"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasBundleAssociation = exports.matchTierPriceByQuantity = exports.hasTiers = exports.tierPrices = exports.isDisabled = exports.isSoldOut = exports.hasExtras = exports.hasVariants = exports.maxPerOrder = exports.minPerOrder = exports.productQuantity = exports.hasStopPolicy = exports.policy = exports.isBundleExclusive = exports.isAvailable = exports.isConfigurable = exports.isBundle = exports.getAvailableMaxQuantity = exports.getAvailableMinQuantity = exports.hasChildren = exports.getChildren = exports.getVariants = exports.getComponentIds = exports.hasSelectedAllConfigurableComponents = exports.outOfStock = void 0;
var catalog_service_1 = require("../../services/catalog-service");
var outOfStock = function (product, quantity) {
    return ((0, exports.hasStopPolicy)(product) && (0, exports.productQuantity)(product) <= 0 && (0, exports.productQuantity)(product) < quantity);
};
exports.outOfStock = outOfStock;
var hasSelectedAllConfigurableComponents = function (product, components) {
    return components.length === product.components.length;
};
exports.hasSelectedAllConfigurableComponents = hasSelectedAllConfigurableComponents;
var getComponentIds = function (product) {
    return (0, exports.isBundle)(product) ? product.components.map(function (component) { return component.product_id; }) : [];
};
exports.getComponentIds = getComponentIds;
var getVariants = function (product) {
    return (0, exports.isConfigurable)(product) ? product.variants || [] : [];
};
exports.getVariants = getVariants;
var getChildren = function (product) {
    return (0, exports.isConfigurable)(product) ? product.children || [] : [];
};
exports.getChildren = getChildren;
var hasChildren = function (product) {
    return (0, exports.isConfigurable)(product) && (product.children || []).length > 0;
};
exports.hasChildren = hasChildren;
var getAvailableMinQuantity = function (product) {
    if (!product.inventory.min_per_order) {
        return 1;
    }
    if (product.inventory.policy === 'stop' &&
        product.inventory.min_per_order > product.inventory.quantity) {
        return 0;
    }
    return product.inventory.min_per_order;
};
exports.getAvailableMinQuantity = getAvailableMinQuantity;
var getAvailableMaxQuantity = function (product) {
    if (product.inventory.policy === 'continue') {
        return product.inventory.max_per_order || 0;
    }
    if (!product.inventory.max_per_order) {
        return product.inventory.quantity;
    }
    return product.inventory.max_per_order < product.inventory.quantity
        ? product.inventory.max_per_order
        : product.inventory.quantity;
};
exports.getAvailableMaxQuantity = getAvailableMaxQuantity;
var isBundle = function (product) {
    return product.classification === 'bundle';
};
exports.isBundle = isBundle;
var isConfigurable = function (product) {
    return (product.classification === catalog_service_1.ProductClassification.COMMON &&
        ('children' in product || 'variants' in product));
};
exports.isConfigurable = isConfigurable;
var isAvailable = function (product) {
    return !!product.inventory.is_available;
};
exports.isAvailable = isAvailable;
var isBundleExclusive = function (product) {
    return product.inventory.is_bundle_exclusive === true;
};
exports.isBundleExclusive = isBundleExclusive;
var policy = function (product) {
    return product.inventory.policy;
};
exports.policy = policy;
var hasStopPolicy = function (product) {
    return (0, exports.policy)(product) === 'stop';
};
exports.hasStopPolicy = hasStopPolicy;
var productQuantity = function (product) {
    return product.inventory.quantity;
};
exports.productQuantity = productQuantity;
var minPerOrder = function (product) {
    return product.inventory.min_per_order;
};
exports.minPerOrder = minPerOrder;
var maxPerOrder = function (product) {
    return product.inventory.max_per_order;
};
exports.maxPerOrder = maxPerOrder;
var hasVariants = function (product) {
    return (0, exports.isConfigurable)(product) && (product.variants || []).length > 0;
};
exports.hasVariants = hasVariants;
var hasExtras = function (product) {
    if (product.parent) {
        return (0, exports.hasExtras)(product.parent);
    }
    return (product.extras || []).length > 0;
};
exports.hasExtras = hasExtras;
var isSoldOut = function (product, quantity) {
    if (quantity === void 0) { quantity = 1; }
    var inventoryMinPerOrder = (0, exports.minPerOrder)(product);
    if (inventoryMinPerOrder && quantity < inventoryMinPerOrder) {
        return true;
    }
    var inventoryMaxPerOrder = (0, exports.maxPerOrder)(product);
    if (inventoryMaxPerOrder && quantity > inventoryMaxPerOrder) {
        return true;
    }
    return (0, exports.outOfStock)(product, quantity);
};
exports.isSoldOut = isSoldOut;
var isDisabled = function (product, quantity, components) {
    if (quantity === void 0) { quantity = 1; }
    if (components === void 0) { components = []; }
    if ((0, exports.isBundle)(product) && (0, exports.hasSelectedAllConfigurableComponents)(product, components)) {
        return false;
    }
    if ((0, exports.hasVariants)(product)) {
        return true;
    }
    return (0, exports.isSoldOut)({ inventory: product.inventory }, quantity);
};
exports.isDisabled = isDisabled;
var tierPrices = function (product) {
    return __spreadArray([], (product.tiers || []), true).sort(function (a, b) { return a.quantity - b.quantity; });
};
exports.tierPrices = tierPrices;
var hasTiers = function (product) {
    return (0, exports.tierPrices)(product).length > 0;
};
exports.hasTiers = hasTiers;
var matchTierPriceByQuantity = function (product, quantity) {
    return (0, exports.tierPrices)(product)
        .reverse()
        .find(function (tier) { return tier.quantity <= quantity; });
};
exports.matchTierPriceByQuantity = matchTierPriceByQuantity;
var hasBundleAssociation = function (product) {
    return (product.associated_with_bundles || []).length > 0;
};
exports.hasBundleAssociation = hasBundleAssociation;
//# sourceMappingURL=product-helpers.js.map